var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySpaceSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 324,
    viewBox: "0 0 432 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.479 1.57594C254.297 7.56819 268.651 44.9422 295.644 66.1777C330.258 93.4099 386.984 98.7345 398.135 141.342C410.204 187.455 382.249 235.707 348.933 269.796C315.247 304.265 268.311 329.041 220.479 323.125C176.044 317.63 152.639 272.488 120.3 241.521C86.6528 209.301 32.2927 187.9 30.6432 141.342C28.9817 94.4472 75.1534 61.625 112.941 33.804C144.268 10.7395 182.174 -5.21148 220.479 1.57594Z",
    fill: "url(#paint0_linear_20510_403714)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.184 3.07716C274.382 3.04677 304.645 46.2164 334.252 80.3675C360.967 111.182 383.834 144.799 387.28 185.436C391.055 229.97 389.342 282.98 353.719 309.971C319.297 336.051 272.299 307.686 229.184 305.218C190.647 303.013 150.598 317.367 118.134 296.485C79.0511 271.347 41.6408 231.887 42.9576 185.436C44.261 139.458 91.3927 112.69 124.257 80.5087C156.543 48.893 183.996 3.10756 229.184 3.07716Z",
    fill: "url(#paint1_linear_20510_403714)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.592 142.832H269.2C272.317 142.832 275.306 144.097 277.51 146.347C279.714 148.598 280.953 151.65 280.953 154.832V167.456C280.954 169.025 280.655 170.578 280.071 172.028L261.884 217.118C261.441 218.218 260.687 219.158 259.719 219.819C258.751 220.48 257.613 220.833 256.449 220.832H157.552C155.994 220.832 154.499 220.2 153.397 219.075C152.295 217.95 151.676 216.424 151.676 214.832V154.832C151.676 153.241 152.295 151.715 153.397 150.59C154.499 149.465 155.994 148.832 157.552 148.832H178.013C178.954 148.833 179.881 148.602 180.716 148.161C181.552 147.719 182.271 147.079 182.814 146.294L214.857 99.9324C215.262 99.3463 215.859 98.9278 216.541 98.7528C217.222 98.5778 217.942 98.6578 218.571 98.9784L229.23 104.42C232.23 105.951 234.626 108.484 236.021 111.598C237.416 114.712 237.726 118.22 236.899 121.538L231.592 142.832ZM186.933 158.36V208.832H252.512L269.2 167.456V154.832H231.592C229.802 154.832 228.036 154.414 226.428 153.611C224.821 152.808 223.414 151.64 222.315 150.197C221.217 148.754 220.456 147.074 220.09 145.285C219.724 143.496 219.763 141.646 220.204 139.874L225.51 118.586C225.676 117.922 225.615 117.22 225.336 116.597C225.057 115.974 224.577 115.467 223.977 115.16L220.093 113.18L192.416 153.212C190.947 155.336 189.066 157.076 186.933 158.36V158.36ZM175.181 160.832H163.428V208.832H175.181V160.832Z",
    fill: "#41435B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20510_403714",
    x1: 30.5996,
    y1: 162,
    x2: 400.997,
    y2: 162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20510_403714",
    x1: 42.9238,
    y1: 162,
    x2: 388.672,
    y2: 162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15F0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E95FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySpaceSuccess);
export default __webpack_public_path__ + "static/media/emptySpaceSuccess.7f9e781bf063a67f360ac20489a1661c.svg";
export { ForwardRef as ReactComponent };